// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__ayjrN","title":"style__title__GbQFC","description":"style__description__0hCRR","component":"style__component__zvMKD"};